import { v4 as uuid } from 'uuid';

export const featuredCategories = [
  {
    id: uuid(),
    category: 'Cinematography',
    imgURL:
      'https://images.unsplash.com/photo-1595859703065-2259982784bb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
  },
  {
    id: uuid(),
    category: 'Sound design',
    imgURL:
      'https://images.unsplash.com/photo-1615576447223-fc9e5fae1801?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
  },
  {
    id: uuid(),
    category: 'Photography',
    imgURL:
      'https://images.unsplash.com/photo-1581363900528-321bd7b3ce50?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHBob3RvZ3JhcGhlcnN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60',
  },
];
